import { useMutation } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useBiometricValidation(projectId: string) {
  const mutationKey = queryKeys.INSTALLATION.BIOMETRIC_VALIDATION(projectId)

  const mutationFn = async () => {
    const res = await financialBff('mutation')({
      installation_biometric_validation: [
        {
          input: {
            project_id: projectId,
          },
        },
        {
          reason: true,
          retry_after_seconds: true,
          retry_at: true,
          status: true,
        },
      ],
    })

    return res.installation_biometric_validation
  }

  return useMutation({
    mutationKey,
    mutationFn,
    retry: 0,
  })
}
